<template>
  <modal-v2 relaxed-header :show="show" :on-close="closeModal">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header-v2
        :header-title="$t('INTEGRATION_SETTINGS.DOCAL.CTA_MODAL.TITLE')"
        :header-content="$t('INTEGRATION_SETTINGS.DOCAL.CTA_MODAL.DESCRIPTION')"
      />

      <div class="px-6 py-5 pb-6">
        <div
          class="bg-[#EFF6FF] border border-blue-100 rounded-[4px] p-[11px] pb-[9px] rtl:pb-[11px] flex flex-row gap-2"
        >
          <span class="material-symbols-outlined text-[24px] text-[#2563EB]">
            info
          </span>
          <div>
            <div class="text-base leading-6 font-semibold text-[#1E3A8A]">
              {{ $t('INTEGRATION_SETTINGS.DOCAL.CTA_MODAL.NOTE_LABEL') }}
            </div>
            <div class="text-sm leading-5 text-[#2563EB] mt-0.5 rtl:mt-1">
              {{ $t('INTEGRATION_SETTINGS.DOCAL.CTA_MODAL.NOTE') }}
            </div>
          </div>
        </div>

        <div class="text-base leading-6 font-semibold text-gray-800 mt-4">
          {{ $t('INTEGRATION_SETTINGS.DOCAL.CTA_MODAL.WHAT_YOU_CAN_DO') }}
        </div>
        <div class="mt-2 flex flex-col gap-2">
          <div
            v-for="(feature, index) in features"
            :key="index"
            class="flex flex-row items-center gap-1"
          >
            <span class="w-6 h-6 flex items-center justify-center shrink-0">
              <span class="w-1 h-1 bg-gray-400 rounded-full" />
            </span>
            <span class="text-sm leading-5 text-gray-600">{{ feature }}</span>
          </div>
        </div>
      </div>
    </div>
  </modal-v2>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    features() {
      return this.$t('INTEGRATION_SETTINGS.DOCAL.CTA_MODAL.FEATURES');
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
